import React, { useEffect, useState, useRef } from 'react';
import { Footer, Navbar } from "../components";
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL, ACCESS_TOKEN_NAME, Image_Base_Url, ACCESS_Role_ID, ACCESS_Log_In_User_Id } from '../constants/apiConstants';
import '../assets/css/bootstrap.min.css';
import '../assets/css/fontawesome-all.min.css';
import '../assets/css/slick.css';
import '../assets/css/line-awesome.min.css';
import '../assets/css/main.css';
import '../assets/css/responsive.css';
import '../assets/stylesheet/style.css'
import { Modal, Button, Form } from "react-bootstrap";

import FeedImage from '../../src/assets/img/exam/ins1.png'
import ImportantLinks from '../components/ImportantLinks';


const Examdetail = () => {
  const [selectedTab, setSelectedTab] = useState("overview");

  const [description, setDescription] = useState([]); // State to hold roles data
  const [overView, setOverView] = useState([]);
  const [ExamPreparationTestSeries, setExamPreparationTestSeries] = useState([])
  const [ExamPreparationExamInfo, setExamPreparationExamInfo] = useState([])
  const [loading, setLoading] = useState(true); // State to track loading status
  const [error, setError] = useState(null); // State to hold error messages
  const navigate = useNavigate();
  const [showFormModal, setShowFormModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [formData, setFormData] = useState({
    phone: "",
  });
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [showFormModal1, setShowFormModal1] = useState(false);
  const [showOtpModal1, setShowOtpModal1] = useState(false);
  const [formData1, setFormData1] = useState({
    phone1: "",
  });
  const [otp1, setOtp1] = useState(["", "", "", "", "", ""]);
  const { id } = useParams();


  console.log("ACCESS_Log_In_User_Id" + ACCESS_Log_In_User_Id());

  // Empty dependency array to run only on mount


  const fetchDescription = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/getExamPreparationExamDescriptionByPaperId/${id}`);

      // console.log("data of the api will be",response.data)
      setDescription(response.data)
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };
  const handleChange1 = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleChange2 = (e) => {
    setFormData({ ...formData1, [e.target.name]: e.target.value });
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      alert("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      const formdata = new FormData();
 
      formdata.append("mobile_no", formData.phone);
      formdata.append("code", finalOtp);

      const response = await axios.post(`${API_BASE_URL}/verifyPhoneDownloadBrochure`, formdata, {
        headers: { "Content-Type": "multipart/form-data" }, // Ensure proper headers for FormData
      });
      console.log("api response verify send otp", response)
      if (response.data.status == 'success') {
        alert("OTP verified!");
        fetchMedia1()
        // window.location.href = "/brochure.pdf"; // Update with actual file path
        setShowOtpModal(false);
      } else {
        alert("Invalid OTP, please try again.");
      }
    } catch (error) {
      console.error("OTP verification failed", error);
      //   alert("OTP verification failed.");
    }
  };


  const handleOtpSubmit1 = async (e) => {
    e.preventDefault();
    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      alert("Please enter a valid 6-digit OTP.");
      return;
    }

    try {
      const formdata = new FormData();
  
      formdata.append("mobile_no", formData.phone1);
      formdata.append("code", finalOtp);

      const response = await axios.post(`${API_BASE_URL}/verifyPhoneDownloadBrochure`, formdata, {
        headers: { "Content-Type": "multipart/form-data" }, // Ensure proper headers for FormData
      });
      console.log("api response verify send otp", response)
      if (response.data.status == 'success') {
        alert("OTP verified!");
        fetchMedia1()
        // window.location.href = "/brochure.pdf"; // Update with actual file path
        setShowOtpModal(false);
      } else {
        alert("Invalid OTP, please try again.");
      }
    } catch (error) {
      console.error("OTP verification failed", error);
      //   alert("OTP verification failed.");
    }
  };

  const fetchOverView = async () => {
    // alert(id)
    try {
      const response = await axios.get(`${API_BASE_URL}/getExamPreparationOverviewByPaperId/${id}`);

      console.log("data of the api will be1234", response.data)
      setOverView(response.data)
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchExamPreparationTestSeries = async () => {
    // alert(id)
    try {
      const response = await axios.get(`${API_BASE_URL}/getExamPreparationTestSeriesByPaperId/${id}`);

      console.log("data of the api will be1234", response.data)
      setExamPreparationTestSeries(response.data)
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };


  const fetchgetExamPreparationExamInfoById = async () => {
    // alert(id)
    try {
      const response = await axios.get(`${API_BASE_URL}/getExamPreparationExamInfoByPaperId/${id}`);

      console.log("data of the api will be1234", response.data)
      setExamPreparationExamInfo(response.data)
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDescription();
    fetchOverView()
    fetchExamPreparationTestSeries()
    fetchgetExamPreparationExamInfoById()
  }, []);



  const fetchMedia1 = async () => {
    // alert(ids)
    axios.get(`${API_BASE_URL}/getDownloadBrochureFileBasedOnUserId?user_id=${id}`)
      .then(function (response) {
        console.log("fsdhfk kjsdhkjshd", response.data.data);
        if (response.data.code == 200) {
          // setMediapdf(response.data.data);
          downloadPDF(response.data.data[0].media_image_path)
          // window.location.href = response.data.data[0].media_image_path
        }
      })
      .catch(function (error) {
      });
  };

  const handleOtpChange = (index, value) => {
    if (!/^\d*$/.test(value)) return; // Only allow numbers
    let newOtp = [...otp];
    newOtp[index] = value.slice(0, 1); // Restrict to 1 digit
    setOtp(newOtp);

    // Move to next input field automatically
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleOtpChange1 = (index, value) => {
    if (!/^\d*$/.test(value)) return; // Only allow numbers
    let newOtp = [...otp1];
    newOtp[index] = value.slice(0, 1); // Restrict to 1 digit
    setOtp1(newOtp);

    // Move to next input field automatically
    if (value && index < 5) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const downloadPDF = (filePath) => {
    if (!filePath) {
      alert("File not found!");
      return;
    }

    // Construct the complete file URL (modify API_BASE_URL accordingly)
    const fileUrl = `${Image_Base_Url}/${filePath}`;

    // Create a hidden <a> element to trigger the download
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "brochure.pdf");

    // Append link to body, trigger click, then remove link
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };



  const handleDownloadClick = async (e) => {
    e.preventDefault();

    // if (ACCESS_TOKEN_NAME()) {
    //   // If token exists, allow download
    //   // window.location.href = "/brochure.pdf"; // Update with actual file path


    //   fetchMedia1()
    // } else {
      // If no token, show OTP verification modal
      setShowFormModal(true);
    // }
  };

  const handleDownloadClick1 = async (e) => {
    e.preventDefault();

    // if (ACCESS_TOKEN_NAME()) {
    //   // If token exists, allow download
    //   // window.location.href = "/brochure.pdf"; // Update with actual file path


    //   fetchMedia1()
    // } else {
      // If no token, show OTP verification modal
      setShowFormModal1(true);
    // }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    // Validation check
    if (!formData.phone) {
      alert("Mobile  are required!");
      return;
    }

    try {
      // Hide form modal and show OTP modal
      setShowFormModal(false);
      setShowOtpModal(true);

      // Call API to send OTP
      const response = await axios.post(`${API_BASE_URL}/sendMobileVerificationDownloadBrochureRequest`, {
        mobile_no: formData.phone,
      });
      console.log("api response send otp", response)
      if (response.data.status == 'success') {
        alert("OTP sent successfully!");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      //   alert("Failed to send OTP. Please try again.");
    }
  };


  const handleFormSubmit1 = async (e) => {
    e.preventDefault();

    // Validation check
    if (!formData.phone1) {
      alert("Mobile  are required!");
      return;
    }

    try {
      // Hide form modal and show OTP modal
      setShowFormModal1(false);
      setShowOtpModal1(true);

      // Call API to send OTP
      const response = await axios.post(`${API_BASE_URL}/sendMobileVerificationDownloadBrochureRequest`, {
        mobile_no: formData.phone,
      });
      console.log("api response send otp", response)
      if (response.data.status == 'success') {
        alert("OTP sent successfully!");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      //   alert("Failed to send OTP. Please try again.");
    }
  };




  const fileInputRef = useRef(null);

  const handleMediaClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    console.log('Selected files:', files);

  };
  const showModal = () => {
    const bootstrap = require('bootstrap');
    const myModal = new bootstrap.Modal(document.getElementById('postModal'), {
      backdrop: 'static',
      keyboard: false
    });
    myModal.show();
  }

  console.log("render item of the data", ExamPreparationTestSeries, ExamPreparationExamInfo, description, overView)
  return (
    <div >
      {/* Scroll to Top */}
      <div className="progress-wrap">
        <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
          <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
      </div>

      {/* Mobile Menu */}
      <div className="mobile-menu d-lg-none d-block">
        <button type="button" className="close-button">
          <i className="las la-times"></i>
        </button>
        <div className="mobile-menu__inner">
          <ul className="nav-menu flx-align nav-menu--mobile">
            <li className="nav-menu__item activePage">
              <a href="/" className="nav-menu__link">Home</a>
            </li>
            {/* Add other menu items here */}
          </ul>
          <div className="header-right__inner d-lg-none my-3 gap-1 d-flex flx-align">
            <a href="/" className="btn btn-main pill sign_btn px-sm-4">
              Signup/Login
            </a>
          </div>
        </div>
      </div>

      {/* <img className="shape_top d-lg-block d-none" src={shapeImage} alt="" />
      <img className="shape_top_6 d-xl-block d-none" src={shapeImage1} alt="" /> */}


      <Navbar />

      <main class="main bg_all" >

        <div class="site-breadcrumb test_series_pd">
          <div class="container">
            {/* <h2 class="breadcrumb-title">SSC CGL 2025 Notification, Eligibility, Online Form & Exam Date</h2> */}
            <h2 class="breadcrumb-title">{description[0]?.heading}</h2>
            <ul class="breadcrumb-menu">
              <li><a href="index-2.html">Home</a></li>
              <li class="active">SSC CGL</li>
            </ul>
            <div class="item__enrolled">
              {/* <span><i class="fa-light fa-user"></i> 7307.8k+ Students Enrolled </span> */}
              <span><i class="fa-light fa-user"></i> {description[0]?.students_enrolled_count}k+ Students Enrolled </span>
              {/* <span><i class="fa-light fa-calendar-days"></i> Last Updated on Apr 7, 2025  </span> */}
              <span><i class="fa-light fa-calendar-days"></i> Last Updated on {description[0]?.last_update}  </span>

            </div>
            <a href="#" class="theme-btn mt-2" onClick={handleDownloadClick1}> Get started for free!</a>
            <a href="#" class="theme-btn mt-2 ms-2" onClick={handleDownloadClick}> Download As Pdf</a>

          </div>
        </div>


        <div class="clear"></div>
        <div class="fixed-scrll py-3">
          <div class="container">
            <div class="blog-details-tags">
              <nav>
                <ul>
                  <li><a href="#overview" class="active">Overview</a></li>
                  <li><a href="#test">Test Series</a></li>
                
                  <li><a href="#exam">Exam Info</a></li>
                  <li><a href="/prevPaper/:id">Prev. Papers</a></li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <div class="course-single-area pb-5">
          <div class="container">
            <div class="course-single-wrapper">
              <div class="row">
                <div class="col-xl-8 col-lg-8">
                  <div class="course-details course_wraper">

                    <div class="course-details fixed-scrll">
                      <div class="blog-details-tags pb-20">

                      </div>

                      <div class="sections">

                        <p class="mb-20" id="overview" >
                          <h4>{overView[0]?.heading}</h4>
                        </p>


                       

                        <p class="mb-20" id="overview" dangerouslySetInnerHTML={{ __html: overView[0]?.overview_description }} />
                        <div class="my-4" id="test">
                          <div class="mb-3">
                            <h3 class="mb-3">SSC CGL Free Test</h3>
                            <div class="row">
                              <div class="col-md-4">
                                {ExamPreparationTestSeries.map((item, index) => {
                                  <div class="test_series">
                                    <div class="tst_logo_wrap">
                                      <div class="logo_tst_srs">{item.media_image_path ? (
                                        <img
                                          src={`${Image_Base_Url}${item.media_image_path}`}
                                          alt="Lobo"
                                          style={{ width: "50px", height: "50px" }}
                                        />
                                      ) : (
                                        "No Image"
                                      )}</div>
                                      <div class="usr_count">{item?.user_count}k Users</div>
                                    </div>
                                    <p class="pt-2 pb-3">NEET UG Mock Test Series 2025</p>
                                    <p class="total_test_wraper">

                                      <span class="tst_wrap_txt">{item?.total_tests}</span>
                                      <span class="tst_wrap_txt grn_wrap">{item?.free_tests}</span>
                                    </p>
                                    <p class="orange pt-2 highligt_orng">{item?.languages}</p>
                                    <ul dangerouslySetInnerHTML={{ __html: item.description}} />
                                      {/* <li>91 ALP & SI 2024 PYP Qs</li>
                                      <li>3 ALP & SI 2024 PYP Repeated Qs</li>
                                      <li>5 Railway Latest Pattern FT</li>
                                      <li>+1062 more tests</li>
                                    </ul> */}
                                    <a href="#" class="theme-btn">View Test Series</a>
                                  </div>

                                })}
                              </div>
                           
                            </div>
                          </div>

                        </div>



        



                        <div class="exam faq-area" id="exam">
                          {/* <h3 class="mb-3">SSC CGL Exam 2025 FAQs</h3> */}
                          <h3 class="mb-3">{ExamPreparationExamInfo[0]?.title}</h3>

                          <div class="col-lg-12">
                          

                            <div className="accordion" id="accordionExample">
                              {ExamPreparationExamInfo.map((item, index) => {
                                const uniqueId = `item-${item.id || index}`;
                                return (
                                  <div className="accordion-item" key={uniqueId}>
                                    <h2 className="accordion-header" id={`heading${uniqueId}`}>
                                      <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse${uniqueId}`}
                                        aria-expanded="false"
                                        aria-controls={`collapse${uniqueId}`}
                                        style={{
                                          color: "#00796b",
                                          fontWeight: "600",
                                          fontSize: "16px",
                                        }}
                                      >
                                        {item.heading}
                                      </button>
                                    </h2>
                                    <div
                                      id={`collapse${uniqueId}`}
                                      className="accordion-collapse collapse"
                                      aria-labelledby={`heading${uniqueId}`}
                                      data-bs-parent="#accordionExample"
                                    >
                                      <div
                                        className="accordion-body"
                                        style={{
                                          fontSize: "15px",
                                          lineHeight: "1.6",
                                          color: "#333",
                                          fontWeight: "500",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: item.overview_description,
                                        }}
                                      />
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>


                  </div>
                </div>
                <div class="col-xl-4 col-lg-4">
                  <div class="course-single-sidebar course_wraper-right">

                              <ImportantLinks/>


                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{fontSize:'18px'}}>Sign Up and start you exam preparation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleFormSubmit}>
           
              <Form.Group>
                <Form.Label style={{ fontWeight: "bold", textAlign: "left", display: "block" }}>Phone</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange1}
                  required
                  placeholder="Enter your phone number"
                  style={{ borderColor: formData.phone ? "#ccc" : "red" }}
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="mt-3" style={{backgroundColor:'orange',color:'white'}}>
                Submit
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        {/* OTP Modal */}
        <Modal show={showOtpModal} onHide={() => setShowOtpModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Enter OTP</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleOtpSubmit} style={{ textAlign: "center" }}>
              <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>
                Enter 6-digit OTP
              </Form.Label>
              <div style={{ display: "flex", justifyContent: "center", gap: "10px", margin: "10px 0" }}>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    value={digit}
                    onChange={(e) => handleOtpChange(index, e.target.value)}
                    maxLength="1"
                    style={{
                      width: "40px",
                      height: "40px",
                      textAlign: "center",
                      fontSize: "18px",
                      fontWeight: "bold",
                      border: "2px solid #007bff",
                      borderRadius: "5px",
                    }}
                  />
                ))}
              </div>
              <Button variant="success" type="submit" className="mt-3" style={{backgroundColor:'orange',color:'white'}}>
                Verify OTP
              </Button>
            </Form>
          </Modal.Body>
        </Modal>


        <Modal show={showFormModal1} onHide={() => setShowFormModal1(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{fontSize:'18px'}}>Sign Up and start you exam preparation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleFormSubmit1}>
           
              <Form.Group>
                <Form.Label style={{ fontWeight: "bold", textAlign: "left", display: "block" }}>Phone</Form.Label>
                <Form.Control
                  type="tel"
                  name="phone1"
                  value={formData.phone1}
                  onChange={handleChange2}
                  required
                  placeholder="Enter your phone number"
                  style={{ borderColor: formData.phone1 ? "#ccc" : "red" }}
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="mt-3" style={{backgroundColor:'orange',color:'white'}}>
                Submit
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        {/* OTP Modal */}
        <Modal show={showOtpModal1} onHide={() => setShowOtpModal1(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Enter OTP</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={handleOtpSubmit1} style={{ textAlign: "center" }}>
              <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>
                Enter 6-digit OTP
              </Form.Label>
              <div style={{ display: "flex", justifyContent: "center", gap: "10px", margin: "10px 0" }}>
                {otp1.map((digit, index) => (
                  <input
                    key={index}
                    id={`otp-${index}`}
                    type="text"
                    value={digit}
                    onChange={(e) => handleOtpChange1(index, e.target.value)}
                    maxLength="1"
                    style={{
                      width: "40px",
                      height: "40px",
                      textAlign: "center",
                      fontSize: "18px",
                      fontWeight: "bold",
                      border: "2px solid #007bff",
                      borderRadius: "5px",
                    }}
                  />
                ))}
              </div>
              <Button variant="success" type="submit" className="mt-3" style={{backgroundColor:'orange',color:'white'}}>
                Verify OTP
              </Button>
            </Form>
          </Modal.Body>
        </Modal>


      </main>

      <button class="btn btn-primary enquire_now" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight">Enquire Now</button>

      <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
          <h4 id="offcanvasRightLabel">Enquire <span class="orange">Now</span></h4>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body">
          <div class="row contact-form py-0">
            <div class="col-md-12">
              <div class="form-group">
                <input type="text" class="form-control" name="name" placeholder="Your Name" required="" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <input type="email" class="form-control" name="email" placeholder="Your Email" required="" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <input type="phone" class="form-control" name="phone" placeholder="Your Contact Number" required="" />
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <select class="form-select form-control" aria-label="city">
                    <option selected>City</option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <select class="form-select form-control" aria-label="courses">
                    <option selected>Courses</option>
                    <option value="1">MBA</option>
                    <option value="2">BBA</option>
                    <option value="3">Btech</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <select class="form-select form-control" aria-label="courses">
                    <option selected>College for Admission</option>
                    <option value="1">MBA</option>
                    <option value="2">BBA</option>
                    <option value="3">Btech</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <textarea name="message" cols="30" rows="2" class="form-control" placeholder="Write Your Message"></textarea>
                </div>
              </div>
              <button type="submit" class="theme-btn">Submit
                <i class="far fa-paper-plane"></i></button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Examdetail;
